import { local } from '@/utils/storage.js'

const TOKEY_KEY = 'TOKEY_KEY'
export const setToken = function (val) {
  return local.set(TOKEY_KEY, val)
}

export const getToken = function () {
  return local.get(TOKEY_KEY)
}

export const isWeiXin = () => /MicroMessenger/i.test(window.navigator.userAgent)

/**
 * 手机号
 * @param {*} phoneNumber
 */
 export const isPhoneNumber = (phoneNumber) => /^(0|86|17951)?(13[0-9]|15[012356789]|16[678]|17[678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(phoneNumber)

export const isMobile = () => {
  const userAgentInfo = navigator.userAgent
  const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
  let mobile_flag = false
  // 根据userAgent判断是否是手机
  for (let v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true
          break;
      }
  }
  const screen_width = window.screen.width
  const screen_height = window.screen.height
   // 根据屏幕分辨率判断是否是手机
   if (screen_width < 500 && screen_height < 800) {
       mobile_flag = true
   }
   return mobile_flag
}
export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  const len = arr.length
  while (++i < len) {
    const item = arr[i]
    fn(item, i, arr)
  }
}
/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  const len = Math.min(arr1.length, arr2.length)
  let i = -1
  const res = []
  while (++i < len) {
    const item = arr2[i]
    if (arr1.indexOf(item) > -1) res.push(item)
  }
  return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => targetarr.some(_ => arr.indexOf(_) > -1)
/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
 export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}
/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
  const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => timeStamp < currentTime

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => (num < 10 ? `0${num}` : num)
/**
 * 判断时间间隔多少小时
 * */
export const judgeTimeDiffer = (startTime, endTime) => parseInt((startTime - endTime) / 1000 / 60 / 60)
/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
  if (!timeStamp) {
    return ''
  }
  const d = new Date(timeStamp * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (startType === 'Y-M-D') {
    resStr = `${year}-${month}-${date}${hours}:${minutes}:${second}`
  } if (startType === 'M-D') {
    resStr = `${month}-${date} ${hours}:${minutes}`
  } else {
    resStr = `${year}-${month}-${date} ${hours}:${minutes}:${second}`
  }
  return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
  // 判断当前传入的时间戳是秒格式还是毫秒
  const IS_MILLISECOND = isMillisecond(timeStamp)
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp / 1000)
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp)
  // 获取当前时间时间戳
  const currentTime = Math.floor(Date.parse(new Date()) / 1000)
  // 判断传入时间戳是否早于当前时间戳
  const IS_EARLY = isEarly(timeStamp, currentTime)
  // 获取两个时间戳差值
  let diff = currentTime - timeStamp
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff
  let resStr = ''
  const dirStr = IS_EARLY ? '前' : '后'
  // 少于等于59秒
  if (diff <= 59) resStr = `${diff}秒${dirStr}`
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = `${Math.floor(diff / 60)}分钟${dirStr}`
  // 多于59分钟59秒，少于等于23小时59分钟59秒
  else if (diff > 3599 && diff <= 86399) resStr = `${Math.floor(diff / 3600)}小时${dirStr}`
  // 多于23小时59分钟59秒，少于等于29天59分钟59秒
  else if (diff > 86399 && diff <= 2623859) resStr = `${Math.floor(diff / 86400)}天${dirStr}`
  // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
  else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp)
  else resStr = getDate(timeStamp, 'year')
  return resStr
}
export const nowInDateBetwen = (d1, d2, date) => {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  const dateBegin = new Date(d1.replace(/-/g, '/'))// 将-转化为/，使用new Date
  const dateEnd = new Date(d2.replace(/-/g, '/'))// 将-转化为/，使用new Date
  const dateNow = new Date(date.replace(/-/g, '/'))// 将-转化为/，使用new Date
  // var dateBegin = new Date(d1);//将-转化为/，使用new Date
  // var dateEnd = new Date(d2);//将-转化为/，使用new Date
  // var dateNow = new Date();//获取当前时间

  const beginDiff = dateNow.getTime() - dateBegin.getTime()// 时间差的毫秒数
  const beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000))// 计算出相差天数

  const endDiff = dateEnd.getTime() - dateNow.getTime()// 时间差的毫秒数
  const endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000)) // 计算出相差天数
  if (endDayDiff < 0) { // 已过期
    return false
  }
  if (beginDayDiff < 0) { // 没到开始时间
    return false
  }
  if (endDayDiff === 0) {
    return true
  }
  if (beginDayDiff === 0) {
    return true
  }
  return true
}

/**
 * 获取前后n年并拼接选择框
 */
export function selectData (num = 5) {
  const mydate = new Date()
  const startyear = mydate.getFullYear() - num
  const endyear = mydate.getFullYear() + num
  const Years = []
  for (let i = startyear; i <= endyear; i++) {
    Years.push({ label: `${i}年`, value: i })
  }
  return Years
}
export function selectData2 () {
  const mydate = new Date()
  const endyear = mydate.getFullYear()
  const Years = []
  for (let i = 2019; i <= endyear; i++) {
    Years.push({ label: `${i}年`, value: i })
  }
  return Years
}
export function selectMonthData () {
  const months = []
  for (let i = 1; i <= 12; i++) {
    months.push({ label: `${i}月`, value: i })
  }
  return months
}

/**
 * 获取前n年并拼接选择框
 */
 export function selectBeforeYear(num = 5) {
  const mydate = new Date()
  const startyear = mydate.getFullYear() - num
  const endyear = mydate.getFullYear()
  const Years = []
  for (let i = startyear; i <= endyear; i++) {
    Years.push({ label: `${i}年`, value: i })
  }
  return Years
}

/**
 * 获取后n年并拼接选择框
 */
 export function selectNextYear(num = 5) {
  const mydate = new Date()
  const startyear = mydate.getFullYear() - 3
  const endyear = mydate.getFullYear() + num
  const Years = []
  for (let i = startyear; i <= endyear; i++) {
    Years.push({ label: `${i}年`, value: i })
  }
  return Years
}

export function getNextYear (timeStamp, n = 1) {
    const date = new Date(timeStamp);
    date.setFullYear(date.getFullYear() + n)
    date.setDate(date.getDate() - 1)
    return date.getTime()
}

export function getNextMonth (timeStamp, n = 1) {
  const date = new Date(timeStamp);
  date.setMonth(date.getMonth() + n)
  date.setDate(date.getDate() - 1)
  return date.getTime()
}

export function monthDayDiff(startTime, endTime) {
  const flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
  const start = new Date(startTime);
  const end = new Date(endTime);
  let year = end.getFullYear() - start.getFullYear();
  let month = end.getMonth() - start.getMonth();
  let day = end.getDate() - start.getDate();
  if (month < 0) {
    year--;
    month = end.getMonth() + (12 - start.getMonth());
  }
  if (day < 0) {
    month--;
    const index = flag.findIndex((temp) => temp === start.getMonth() + 1);
    let monthLength;
    if (index <= 6) {
      monthLength = 31;
    } else if (index > 6 && index <= 10) {
      monthLength = 30;
    } else {
      monthLength = 28;
    }
    day = end.getDate() + (monthLength - start.getDate());
  }
  return `${year}年${month}月${day}天`
}

/**
 * 获取之后时间距离现在多少天
 * @param {Object}
 */
export function getBeforeDate (n) {
  let now = new Date()
  let aftertime = new Date(n)
  let year = now.getFullYear()
  let mon = now.getMonth() + 1
  let day = now.getDate()
  let year_after = aftertime.getFullYear()
  let mon_after = aftertime.getMonth() + 1
  let day_after = aftertime.getDate()
  let chs = 0
    // 获取当月的天数
    function DayNumOfMonth(Year, Month) {
        return 32 - new Date(Year, Month - 1, 32).getDate()
    }
    if (aftertime.getTime() - now.getTime() < 0) {
      const temp1 = day_after
      const temp2 = mon_after
      const temp3 = year_after
      day_after = day
      mon_after = mon
      year_after = year
      day = temp1
      mon = temp2
      year = temp3
    }
    if(year == year_after){//不跨年
        if(mon == mon_after){//不跨年不跨月
            chs += day_after-day
        }else{//不跨年跨月
            chs += DayNumOfMonth(year,mon)- day+1//加上第一个不满的
            for(var i=1;i< mon_after-mon;i++){
                chs += DayNumOfMonth(year,mon+i)
            }
            chs += day_after-1//加上
        }
    } else { // 存在跨年
        chs += DayNumOfMonth(year, mon) - day + 1;// 加上开始年份不满的一个月
        for (let m = 1; m < 12 - mon; m++) {
            chs += DayNumOfMonth(year, mon + m);
        }
        for(var j = 1; j < year_after - year; j++){
            if((year+j)%400 == 0 || (year+j)%4 == 0 && (year+j)%100 != 0){
                chs += 366;
            }else{
                chs += 365;
            }
        }
        for(var n=1;n <= mon_after;n++){
            chs += DayNumOfMonth(year_after,n);
        }
        chs += day_after-1;
    }
    if(aftertime.getTime() - now.getTime() < 0){
        return -chs;
    }else{
         return chs;
    }
}

/**
 * 获取某月每一天
 * @param {} date
 * @returns
 */
export const getMonthDay = (date) => {
  const nowdays = date ? new Date(date) : new Date()
  const year = nowdays.getFullYear()
  let month = nowdays.getMonth() + 1
  if (month < 10) {
    month = `0${month}`
  }
  const myDate = new Date(year, month, 0)
  const tempList = []
  for (let i = 1; i <= myDate.getDate(); i++) {
    const weeks = new Array("星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")
    if (i < 10) {
      tempList.push({ day: `${year}-${month}-0${i}`, weekDesc: weeks[new Date(`${year}-${month}-0${i}`).getDay()], weekValue: new Date(`${year}-${month}-0${i}`).getDay() })
    } else {
      tempList.push({ day: `${year}-${month}-${i}`, weekDesc: weeks[new Date(`${year}-${month}-0${i}`).getDay()], weekValue: new Date(`${year}-${month}-0${i}`).getDay() })
    }
  }
  return tempList
};
